import React from 'react';
import { alert } from './utils';
import { updateFileList } from './store/file';
import AlertHighLight from './components/alert-highLight';
import config from './config';
import { IFileInfo } from './type';

let ws: WebSocket, websocketHeartBeatInterval: NodeJS.Timeout, id: string;

export const initWs = () => {
  if (window.localStorage.getItem('id')) {
    id = window.localStorage.getItem('id')!;
  } else {
    id = Date.now().toString(36);
    window.localStorage.setItem('id', id);
  }
  if (window.WebSocket) {
    ws?.close();
    const isHttps = location.protocol === 'https:';
    const domain = config.isProd ? (isHttps ? config.prodServerHost : config.directServerHost) : `${location.hostname}:8888`;
    ws = new WebSocket(`${isHttps ? 'wss' : 'ws'}://${domain}`);
    ws.onopen = () => {
      openWS(ws.readyState);
      if (websocketHeartBeatInterval) clearInterval(websocketHeartBeatInterval);
      websocketHeartBeatInterval = setInterval(() => {
        if (ws.readyState !== 1) {
          console.warn('ws.readyState !== 1 正在重新建立连接...');
          reconnectWs();
        }
      }, 2500);
    };
    ws.onmessage = (data) => incomingMessage(data);
    ws.onerror = (err) => {
      console.error('ws onerror', err);
      // reconnectWs()
    };
    ws.onclose = (ev: CloseEvent) => {
      console.warn('ws onclose ev.code', ev.code);
      // reconnectWs()
    };
  } else {
    console.warn('不支持webSocket！！！');
  }
};

const openWS = (readyState: WebSocket['readyState']) => {
  console.log('connected', readyState);
  console.log('当前用户id', id);
  const msg = {
    type: 'try-connect',
    id,
    date: Date.now(),
  };
  wsSendFunc(msg);
};

const incomingMessage = (buffer: MessageEvent<any>) => {
  try {
    const data = JSON.parse(buffer.data);
    console.info('incomingMessage data', data);
    switch (data.type) {
      case 'response-date':
        console.info(`Roundtrip time: ${Date.now() - data.data} ms`);
        break;
      case 'order-string':
        break;
      case 'get-files-array': {
        const { fileList } = window.$getState().file;
        updateFileListFunc(data, data.data.finalList, fileList, '发现了新的');
        break;
      }
      case 'delete-files-array': {
        const { fileList } = window.$getState().file;
        updateFileListFunc(data, fileList, data.data.finalList, '删除了');
        break;
      }
      case 'heart-beat':
        break;
      case 'socket-heart-beat': {
        const msg = {
          type: 'check-connect',
          id,
          data: 'reply-server-heart-beat',
          date: Date.now(),
        };
        wsSendFunc(msg);
        break;
      }
      default:
        break;
    }
  } catch (err) {
    console.error('onmessage JSON.parse', err);
  }
};

const reconnectWs = () => {
  initWs();
};

const wsSendFunc = (msg: object) => {
  if (ws.readyState === 1) {
    ws.send(JSON.stringify(msg));
  } else {
    console.warn('wsSendFunc ws.readyState !== 1 msg', msg);
    reconnectWs();
    setTimeout(() => {
      wsSendFunc(msg);
    }, 2500);
  }
};

const updateFileListFunc = (data: any, moreList: IFileInfo[], lessList: IFileInfo[], info: string) => {
  if (decodeURIComponent(window.location.pathname) === decodeURIComponent(data.data.currentFolder)) {
    console.log('updateFileListFunc moreList', moreList);
    moreList.some((item1) => {
      let flag = false;
      // console.log('updateFileListFunc lessList', lessList)
      lessList.some((item2) => {
        if (item1.filename === item2.filename) {
          flag = true;
          return true;
        } else {
          return false;
        }
      });
      if (!flag) {
        console.log('updateFileListFunc item1', item1, 'lessList', lessList);
        const { isFolder, filename } = item1;
        const name = isFolder ? '文件夹' : '文件';
        alert(
          <AlertHighLight
            textFragment={`${info}<span class="delete-alert">${name}</span>，${name}名称：<span class="delete-alert">${filename}</span>`}
          />,
        );
        return true;
      } else {
        return false;
      }
    });
    $dispatch(updateFileList(data.data.finalList));
  }
};
